export enum DatePayableStatus {
  Paid = "Liberado",
  Foreseen = "Previsto",
  ToBeConfirmed = "A confirmar",
  Rejected = "Rejeitado",
  Refund = "Estornado",
}
